import axios from 'axios';
import { startLoader, stopLoader } from '../components/common/loader'; // 👈 your custom loader methods
import { getAuthHeader, removeAllLocalStorage, removeAllSessionStorage } from '../utils'; // 👈 assumes this returns { headers: { Authorization: 'Bearer xxx' } }
import { prepareFormDataForImageUpload } from '../imageUploadQuality';

const customAxios = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    // Do not set global Content-Type here!
});

const isMutationMethod = (method = 'get') => !['get', 'head', 'options'].includes(String(method).toLowerCase());

const shouldShowGlobalLoader = (config = {}) => {
    const explicitLoaderPreference = config?.meta?.showLoader;
    if (typeof explicitLoaderPreference === 'boolean') {
        return explicitLoaderPreference;
    }

    if (config?.meta?.skipLoader === true) {
        return false;
    }

    // On slow links we avoid blocking the entire UI for read-only requests.
    return isMutationMethod(config?.method);
};

customAxios.interceptors.request.use(
    async (config) => {
        const requestMethod = String(config?.method || 'get').toLowerCase();
        const isMutation = isMutationMethod(requestMethod);

        if (isMutation && config.data !== undefined) {
            config.data = await prepareFormDataForImageUpload(config.data);
        }

        const enableLoader = shouldShowGlobalLoader(config);
        config.__loaderEnabled = enableLoader;
        if (enableLoader) {
            startLoader();
        }

        const authHeader = getAuthHeader();
        if (authHeader?.headers) {
            config.headers = {
                ...config.headers,
                ...authHeader.headers,
            };
        }
        if (!config.headers) {
            config.headers = {};
        }

        // Avoid sending JSON Content-Type on GET/HEAD/OPTIONS. It can trigger CORS preflight.
        if (isMutation && config.data !== undefined && !(config.data instanceof FormData)) {
            config.headers['Content-Type'] = 'application/json';
        }

        if (typeof config.timeout !== 'number') {
            config.timeout = 45000;
        }

        return config;
    },
    (error) => {
        if (error?.config?.__loaderEnabled) {
            stopLoader();
        }
        return Promise.reject(error);
    }
);

customAxios.interceptors.response.use(
    (response) => {
        if (response?.config?.__loaderEnabled) {
            stopLoader();
        }
        return response;
    },
    (error) => {
        if (error?.config?.__loaderEnabled) {
            stopLoader();
        }

        if (error.response) {
            const { status, data } = error.response;

            if (status === 403) {
                // Backend se jo error message aa raha h vo check karo
                const errorMessage = data?.error?.message;

                if (
                    errorMessage === "Unauthorized" ||
                    errorMessage === "Invalid or expired session"
                ) {
                    // 🚀 Remove token from localStorage
                    removeAllLocalStorage()
                    removeAllSessionStorage()


                    // Optional: user ko login page pe bhej do
                    window.location.href = "/login";
                }
            }
        }

        return Promise.reject(error);
    }
);


export default customAxios;
